module.exports = __webpack_public_path__ + "components/MapControl/svg/Przeprawa promowa.svg?c0d05827";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Przeprawa promowa.svg
// module id = 1983
// module chunks = 0